<script>
    import {createEventDispatcher} from "svelte";

    export let data = [];
    export let columns = [];
    export let settings;

    let defaultSettings = {
        canResetRows: true,
        hasHeader: true,
        sticky: true,
        editable: true,
    }
    let actualSettings = {}
    $: {
        actualSettings = Object.assign(defaultSettings, settings)
    }

    const dispatch = createEventDispatcher();

    let deletedRows = new Set();
    let originalRows = {};
    let rows = [];
    let oldData;
    $: {
        if (oldData !== data) {
            rows = data.map((elem) => Object.assign({}, elem));
            originalRows = data.reduce((hash, elem) => {
                hash[elem.ID] = Object.assign({}, elem);
                return hash
            }, {});
        }
        oldData = data;
    }

    function sortByColumn(column) {
        if (sortBy.column === column)
            sortBy.ascending = !sortBy.ascending;
        else {
            sortBy.column = column;
            sortBy.ascending = true;
        }
    }

    let sortBy = {};

    let sortedRows = [];
    $: {
        let multiplier = (sortBy.ascending) ? 1 : -1;
        let column = sortBy.column;

        sortedRows = rows.sort((a, b) => {
            if (a[column] < b[column])
                return -1 * multiplier;
            if (a[column] > b[column])
                return 1 * multiplier;

            return 0;
        })
    }

    function saveEdit(item, field, value) {
        item[field] = value;
        rows = rows
    }

    function addRow() {
        rows = [
            ...rows,
            { id: null, ...columns.reduce((acc, col) => ({ ...acc, [col.field]: col.defaultValue }), {}) }
        ];
    }

    function saveRows() {
        let result = [];
        for (let i = 0; i < rows.length; i++) {
            let elem = {};
            if (deletedRows.has(rows[i].ID))
                elem = {
                    ID: rows[i].ID,
                        Action: "DELETE",
                }
            else {
                elem = Object.assign({}, rows[i])
                if (rows[i].ID) {
                    if (columns.some(column => isFieldChanged(rows[i].ID, column.field, rows[i][column.field])))
                        elem.Action = "UPDATE";
                    else continue;
                } else {
                    elem.Action = "CREATE";
                }
            }
            result.push(elem);
        }

        dispatch('change', {
            data: result,
        });
    }

    function resetRow(row) {
        if (originalRows[row.ID]) {
            let index = rows.indexOf(row);
            if (index > -1) {
                rows[index] = Object.assign(row, originalRows[row.ID])
            }
        }
    }

    function deleteRow(row) {
        if (row.ID) {
            deletedRows.add(row.ID)
            deletedRows = deletedRows;
        } else {
            rows = rows.filter(elem => elem !== row);
        }
    }

    function cancelDeletion(row) {
        deletedRows.delete(row.ID);
        deletedRows = deletedRows;
    }

    function isFieldChanged(id, field, currentValue) {
        return originalRows[id]?.[field] !== currentValue;
    }
</script>

<table class="bg-white table-auto">
    {#if actualSettings.hasHeader}
    <thead class="{actualSettings.sticky ? 'sticky top-0 z-10 bg-white' : ''}">
    <tr>
        {#each columns as col}
            <th
                on:click={() => {
                    if (col.sortable) sortByColumn(col.field)
                }}
                class:sortable={col.sortable}
            >{col.title}</th>
        {/each}
        {#if actualSettings.editable}
        <th>
            Controls
        </th>
        {/if}
    </tr>
    </thead>
    {/if}
    <tbody>
    {#each sortedRows as row}
        <tr
            class:new={!row.ID}
            class:deleted={deletedRows.has(row.ID)}
        >
            {#each columns as col}
                {@const editView = col.editView(row, col.field)}
                <td
                    class:edited={isFieldChanged(row.ID, col.field, row[col.field])} class="w-fit"
                >
                    <svelte:component this={editView.component} {...editView.props} bind:value={row[col.field]} bind:checked={row[col.field]} on:change={e => saveEdit(row, col.field, e.detail.data)}></svelte:component>
                </td>
            {/each}
            {#if actualSettings.editable}
            <td>
                {#if deletedRows.has(row.ID)}
                    <button
                        class="btn-secondary"
                        on:click={() => cancelDeletion(row)}
                    >
                        Restore
                    </button>
                {:else}
                    <button
                        class="btn-secondary"
                        on:click={() => deleteRow(row)}
                    >
                        Delete
                    </button>
                {/if}
                {#if actualSettings.canResetRows}
                <button
                    class="btn-secondary"
                    on:click={() => resetRow(row)}
                >
                    Reset
                </button>
                {/if}
            </td>
            {/if}
        </tr>
    {/each}
    </tbody>
    {#if actualSettings.editable}
    <tfoot class="{actualSettings.sticky ? 'sticky bottom-0 z-10 bg-white' : ''}">
    <tr>
        <td colspan={columns.length + 1}>
            <button class="btn-primary" on:click={addRow}>Add New</button>
            <button class="btn-primary" on:click={saveRows}>Save Rows</button>
        </td>
    </tr>
    </tfoot>
    {/if}
</table>

<style>
    table {
        border-collapse: collapse;
        width: 100%;
    }
    th,
    td {
        padding: 0.5rem;
        border: 1px solid #ddd;
    }
    th.sortable {
        cursor: pointer;
    }
    tr.new td {
        background-color: lightgreen;
    }
    tr.deleted td {
        background-color: salmon;
    }
    td.edited {
        background-color: lightskyblue;
    }
</style>